<template>
	<div>
		<iframe id="cms-preview" :src="domain" frameborder="0"></iframe>
	</div>
</template>

<script>

import xhrModule from '../modules/xhrModule.js'

export default {
	name: 'preview',
	data () {
		return {
			domain: null
		}
	},

	created () {
		this.fetchProject()
	},

	methods: {
		fetchProject () {
			var url = '/cms/api/projects'
			xhrModule.get(url, this.fetchCompleted.bind(this))
		},

		fetchCompleted (project) {
			xhrModule.get('/cms/src/Application/ssid.php', (r) => {
				var domains = project[Object.keys(project)[0]].domains
				this.domain = domains[Object.keys(domains)[0]].domain + '/cms-preview?ssid=' + r.data
			})
		}
	}
}
</script>
